import TagManager from 'react-gtm-module';

export const useHostVenueAddNewVenueTag = ({ label, hostId, hostName }) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_host_add_new_venue',
      category: 'UI Interaction',
      action: 'Click',
      label,
      hostId,
      hostName
    }
  });
export const useHostVenueEditTag = ({ label, venuName, hostId, hostName }) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_host_venue_edit',
      category: 'UI Interaction',
      action: 'Click',
      label,
      venuName,
      hostId,
      hostName
    }
  });

export const useHostVenueSaveTag = ({ label, hostId, hostName }) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_host_venue_save',
      category: 'UI Interaction',
      action: 'Click',
      label,
      hostId,
      hostName
    }
  });

export const useHostVenueCancelTag = ({ label, hostId, hostName }) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_host_venue_cancel_edit',
      category: 'UI Interaction',
      action: 'Click',
      label,
      hostId,
      hostName
    }
  });

export const useHostVenueAddUnavailableTag = ({ label, hostId, hostName }) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_add_unavailable_dates',
      category: 'UI Interaction',
      action: 'Click',
      label,
      hostId,
      hostName
    }
  });

export const useHostVenueSwitchTag = ({ label, hostId, hostName }) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_host_switch_venue_resume_pause',
      category: 'UI Interaction',
      action: 'Click',
      label,
      hostId,
      hostName
    }
  });
export const useHostVenueNavigateAwayTag = ({ label, hostId, hostName }) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_navigate_away',
      category: 'UI Interaction',
      action: 'Click',
      label,
      hostId,
      hostName
    }
  });
